import { Controller } from '@hotwired/stimulus';
import { Lithuanian } from 'flatpickr/dist/l10n/lt';
import { english } from 'flatpickr/dist/l10n/default';
// Bundle languages together as it's only ~1.5 KB

export default class extends Controller {
  static targets = ['clear', 'input'];

  static values = {
    withTime: Boolean,
  };

  connect() {
    super.connect();

    this.options = {};

    if (this.inputTarget.dataset.pickerOptions) {
        this.options = JSON.parse(this.inputTarget.dataset.pickerOptions);
    }

    this.load();
    this.update();
  }

  update() {
    if (this.hasClearTarget) {
      if (this.inputTarget.value) {
        this.clearTarget.classList.remove('d-none');
      } else {
        this.clearTarget.classList.add('d-none');
      }
    }
  }

  async load() {
    const flatpickr = (await import('flatpickr')).default;

    flatpickr(this.element, {
      dateFormat: this.withTimeValue ? 'Z' : 'Y-m-d',
      allowInput: true,
      locale: await this.getLocale(),
      disableMobile: true,
      wrap: true,
      maxDate: this.inputTarget.dataset.maxDate || undefined,
      minDate: this.inputTarget.dataset.minDate || undefined,
      enableTime: this.withTimeValue || false,
      altInput: true,
      altFormat: this.withTimeValue ? 'Y-m-d H:i' : 'Y-m-d',
      ...this.options,
    });
  }

  async getLocale() {
    switch (document.documentElement.lang.split('-')[0]) {
      case 'lt':
        return Lithuanian;
      default:
        return english;
    }
  }
}
